// extracted by mini-css-extract-plugin
export var avatar = "StockTransferComments-module--avatar--MB1+J";
export var avatarCurrent = "StockTransferComments-module--avatarCurrent--nsrn2";
export var commentBox = "StockTransferComments-module--commentBox--Lkls5";
export var textarea = "StockTransferComments-module--textarea--qsSa3";